/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SubscriptionsImport } from './routes/subscriptions'
import { Route as CanceledImport } from './routes/canceled'
import { Route as BankAutomatiskBetalningImport } from './routes/bank-automatisk-betalning'
import { Route as IndexImport } from './routes/index'
import { Route as SubscriptionSubscriptionidImport } from './routes/subscription.$subscription_id'

// Create/Update Routes

const SubscriptionsRoute = SubscriptionsImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => rootRoute,
} as any)

const CanceledRoute = CanceledImport.update({
  id: '/canceled',
  path: '/canceled',
  getParentRoute: () => rootRoute,
} as any)

const BankAutomatiskBetalningRoute = BankAutomatiskBetalningImport.update({
  id: '/bank-automatisk-betalning',
  path: '/bank-automatisk-betalning',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SubscriptionSubscriptionidRoute = SubscriptionSubscriptionidImport.update(
  {
    id: '/subscription/$subscription_id',
    path: '/subscription/$subscription_id',
    getParentRoute: () => rootRoute,
  } as any,
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/bank-automatisk-betalning': {
      id: '/bank-automatisk-betalning'
      path: '/bank-automatisk-betalning'
      fullPath: '/bank-automatisk-betalning'
      preLoaderRoute: typeof BankAutomatiskBetalningImport
      parentRoute: typeof rootRoute
    }
    '/canceled': {
      id: '/canceled'
      path: '/canceled'
      fullPath: '/canceled'
      preLoaderRoute: typeof CanceledImport
      parentRoute: typeof rootRoute
    }
    '/subscriptions': {
      id: '/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof SubscriptionsImport
      parentRoute: typeof rootRoute
    }
    '/subscription/$subscription_id': {
      id: '/subscription/$subscription_id'
      path: '/subscription/$subscription_id'
      fullPath: '/subscription/$subscription_id'
      preLoaderRoute: typeof SubscriptionSubscriptionidImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bank-automatisk-betalning': typeof BankAutomatiskBetalningRoute
  '/canceled': typeof CanceledRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/subscription/$subscription_id': typeof SubscriptionSubscriptionidRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bank-automatisk-betalning': typeof BankAutomatiskBetalningRoute
  '/canceled': typeof CanceledRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/subscription/$subscription_id': typeof SubscriptionSubscriptionidRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/bank-automatisk-betalning': typeof BankAutomatiskBetalningRoute
  '/canceled': typeof CanceledRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/subscription/$subscription_id': typeof SubscriptionSubscriptionidRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bank-automatisk-betalning'
    | '/canceled'
    | '/subscriptions'
    | '/subscription/$subscription_id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bank-automatisk-betalning'
    | '/canceled'
    | '/subscriptions'
    | '/subscription/$subscription_id'
  id:
    | '__root__'
    | '/'
    | '/bank-automatisk-betalning'
    | '/canceled'
    | '/subscriptions'
    | '/subscription/$subscription_id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BankAutomatiskBetalningRoute: typeof BankAutomatiskBetalningRoute
  CanceledRoute: typeof CanceledRoute
  SubscriptionsRoute: typeof SubscriptionsRoute
  SubscriptionSubscriptionidRoute: typeof SubscriptionSubscriptionidRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BankAutomatiskBetalningRoute: BankAutomatiskBetalningRoute,
  CanceledRoute: CanceledRoute,
  SubscriptionsRoute: SubscriptionsRoute,
  SubscriptionSubscriptionidRoute: SubscriptionSubscriptionidRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/bank-automatisk-betalning",
        "/canceled",
        "/subscriptions",
        "/subscription/$subscription_id"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/bank-automatisk-betalning": {
      "filePath": "bank-automatisk-betalning.tsx"
    },
    "/canceled": {
      "filePath": "canceled.tsx"
    },
    "/subscriptions": {
      "filePath": "subscriptions.tsx"
    },
    "/subscription/$subscription_id": {
      "filePath": "subscription.$subscription_id.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
